import { reactive } from 'vue';

const state = reactive({
  methodKey: ''
});

export default function usePayment() {
  const setPaymentMethodKey = methodKey => {
    state.methodKey = methodKey;
  };

  const getPaymentMethodKey = () => {
    return state.methodKey || null;
  };

  return {
    setPaymentMethodKey,
    getPaymentMethodKey
  };
}
